import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './sic-search-result-teaser.css.lit';
import { wrapLastWord } from '../../../utilities/wrap-last-word';
import { externalLinkText } from '../../../utilities/external-link-text';
import { property } from 'lit/decorators.js';

import headingStyle from '../sic-heading/sic-heading.css.lit';
import defaultVars from './css-variables/search-result-teaser-vars.css.lit';
import '../sic-heading/sic-heading';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';

/**
 * The sicSearchResultTeaser component
 * @element sic-search-result
 *
 * @slot heading
 * @slot eyebrow
 * @slot additional-info
 * @slot description
 * @slot image -- optional
 *
 */

@customElement('sic-search-result-teaser')
export class sicSearchResultTeaser extends OutlineElement {
  slotsController = new SlotsController(this);

  static styles: CSSResultGroup = [componentStyles, headingStyle, defaultVars];

  @property({ type: Boolean, reflect: true, attribute: 'has-image' })
  hasImage: boolean;

  connectedCallback(): void {
    super.connectedCallback();
    const element = this.querySelector('a');
    const elementTarget = element?.getAttribute('target');

    // The purpose of this block of code is to attach on icon to the last word.
    // Links only has an icon if it's an external link so we target that specifically.
    if (elementTarget === '_blank') {
      // Wraps last word in a span.last-word element.
      // span.last-word is where the icon is added via pseudo
      !element?.querySelector('.last-word') &&
        wrapLastWord(element as HTMLElement);

      // Adds external link text for screen readers.
      externalLinkText(element as HTMLElement);
    }
  }

  render(): TemplateResult {
    return html`
      <section class="container">
        ${this.generateConditionalImageSlotMarkup()}
        <div>
          <div class="eyebrow-header">
            ${this.slotsController.conditionalSlot('eyebrow', true)}
          </div>
          ${this.slotsController.conditionalSlot('heading', false)}
          <div class="subHeading">
            ${this.slotsController.conditionalSlot('subHeading')}
          </div>
          ${this.slotsController.conditionalSlot('description', false)}
          ${this.slotsController.conditionalSlot('date')}
        </div>
      </section>
    `;
  }

  generateConditionalImageSlotMarkup() {
    const hasImage = !!this.querySelectorAll('[slot="image"]').length;
    if (hasImage) {
      this.hasImage = true;
      return html` <div class="search-results--image">
        <slot name="image"></slot>
      </div>`;
    } else {
      return null;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-search-result-teaser': sicSearchResultTeaser;
  }
}
